export const requestOrderInvalidNumberInputCharacters = ["-", "e", "."];
